<template>
  <div class="living-options-subsections">
    <div class="row">
      <div class="col-12">
        <div class="subsections">
          <h5>{{ subsectionGroupLabel }}s</h5>
          <button class="btn btn-primary mb-4" @click="addSubsectionGroup()">Add {{ subsectionGroupLabel}}</button>
          <div class="mb-2">
            <input class="form-control" type="text" v-model="subsectionFilterText" :placeholder="`Filter ${subsectionGroupLabel}s`">
          </div>

            <v-table
              :columns="[
                { label: 'Label', field: 'label'},
                { label: 'Visually Hidden', field: 'isVisuallyHidden'}
              ]"
              :rows="filteredSubsectionGroups"
              :show-active-toggle="activeUser.access.indexOf('live-toggle') !== -1"
              save-action="SAVE_SUBSECTION_GROUP"
              @edit="activeSubsectionGroupId = $event._id"
              @clone="cloneSubsectionGroup($event)"
              @delete="deleteSubsection($event._id)"
            />
        </div>
      </div>
    </div>
    <modal-popup :isVisible="!!activeSubsectionGroup" @closeModal="closeModal">
      <div v-if="activeSubsectionGroup" class="modal-row-padding">
        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-12">
              <h3>Editing {{ activeSubsectionGroup.label }}</h3>
            </div>
          </div>
        </div>
        <div class="col-6 mb-4">
          <div class="row">
            <div class="col-6 mb-4">
              Label
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activeSubsectionGroup.label"
                placeholder="i.e. apartment"
              />
            </div>
            <div class="col-6 mb-4">
              Display Name
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activeSubsectionGroup.displayName"
                placeholder="i.e. apartment"
              />
            </div>
            <!-- <div class="col-6 mb-4">
              Is Tag and Slide Hidden <br>
              <toggle-button
                v-model="activeSubsectionGroup.isVisuallyHidden" 
                color="#28a745" 
                :sync="true" 
                :labels="false" 
                :width="50" 
                :height="30" 
                style="margin: 3px 0 0;"
              />
            </div> -->
            <!-- <div class="col-6 mb-4">
              Is Filter Slideout Hidden <br>
              <toggle-button
                v-model="activeSubsectionGroup.isFilterHidden" 
                color="#28a745" 
                :sync="true" 
                :labels="false" 
                :width="50" 
                :height="30" 
                style="margin: 3px 0 0;"
              />
            </div> -->

            <!-- <div class="col-6 mb-4">
              Subsection Type
              <select v-model="activeSubsectionGroup.type" class="form-control">
                <option value="">Select type</option>
                <option value="apartments">Apartments</option>
                <option value="townhouses">Townhouses</option>
                <option value="houses">Houses</option>
                <option value="land">Land</option>
              </select>
            </div> -->

            <div class="col-12 mb-4">
              Description
              <ck-editor v-model="activeSubsectionGroup.description" id="subsectionDescription"></ck-editor>
            </div>

            <div class="col-12 mb-4">
              Issuu Embed Url
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activeSubsectionGroup.issuuEmbedUrl"
                placeholder=""
              />
            </div>

            <div class="col-12 mb-4">
              {{ subsectionGroupLabel }} Background
              <input-asset v-model="activeSubsectionGroup.backgroundImage"></input-asset>
            </div>

            <div class="col-12 mb-4">
              {{ subsectionGroupLabel }} Card Background Image
              <input-asset v-model="activeSubsectionGroup.cardBackgroundImage"></input-asset>
            </div>

            <div class="col-12 mb-4">
              {{ subsectionGroupLabel }} Sidebar Image
              <input-asset v-model="activeSubsectionGroup.minimapImage"></input-asset>
            </div>
          </div>
        </div>

        <div class="col-6 mb-4">
          <div class="row">
            <div class="col-12 mb-4">
              Associated Subsections
              <input-multi-select
                v-model="activeSubsectionGroup.subsectionIds"
                :options="subsectionOptions"
              ></input-multi-select>     
            </div>

            <!-- <div class="col-12 mb-4">
              Subsection Type*
              <p><small>*Only populate for subsections that require subsections as children. i.e Building > Floor</small></p>
              <input
                type="text"
                class="form-control form-control-lg"
                v-model="activeSubsectionGroup.subsectionType"
                placeholder="i.e. block, floor, etc."
              />        
            </div> -->
          </div>
        </div>

        <div class="col-12 mb-4">
          <label>Tags</label>
          <button class="btn btn-primary my-2" @click="addTag">add tag</button>
          <p>
            <info-box>
              <ul>
                <li>Click on the Add Tag button to create a tag</li>
                <li>Reposition tags by clicking and dragging</li>
                <li>Click on a tag to display the edit tag dialog box</li>
              </ul>
            </info-box>
          </p>
          <draggable-elements 
            :tags="activeSubsectionGroup.tags"
            :subsection-ids="activeSubsectionGroup.subsectionIds"
            :background-image="activeSubsectionGroup.backgroundImage"
          />
        </div>        

        <div class="col-12">
          <button class="btn btn-sm btn-outline-danger" @click="closeModal">Cancel</button>
          <button class="btn btn-sm btn-primary ml-1" @click="saveSubsectionGroup(activeSubsectionGroup)">Save</button>
        </div>
      </div>             
    </modal-popup>
  </div>
</template>
<script lang="js">
import _ from 'lodash'
import CkEditor from '@/components/CKEditor'
import DotDropper from '@/components/DotDropper'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import CardTabs from '@/components/Cards/TabsCard'
import VTable from '@/components/VTable'
import LivingOptionTags from '@/components/LivingOptionTags'
import LivingOptionMarkers from '@/components/LivingOptionMarkers'
import InfoBox from '@/components/InfoBox'
import DraggableElements from '@/components/DraggableElements'

export default {
  components: { CardTabs, CkEditor, DotDropper, InputAsset, InputMultiSelect, VTable, LivingOptionTags, LivingOptionMarkers, InfoBox, DraggableElements },
  
  data () {
    return {
      activeSubsectionGroupId: null,
      subsectionFilterText: '',
      subsectionGroupLabel: this.$store.state.config.projectConfig.nowSelling.subsectionGroup.label
    }
  },

  computed: {
    activeSubsectionGroup () {
      return _.find(this.subsectionGroups, subsectionGroup => {
        return subsectionGroup._id === this.activeSubsectionGroupId
      })
    },

    activeUser () {
      return this.$store.getters.user
    },

    filteredSubsectionGroups () {
      return _.filter(this.subsectionGroups, subsection => {
        return subsection.label.toLowerCase().includes(this.subsectionFilterText.toLowerCase())
      })
    },    

    subsectionGroups: {
      get () {
        return this.$store.getters.subsectionGroups
      },
      set (subsectionGroups) {
        this.$store.commit('SET_SUBSECTION_GROUPS', subsections)
      }
    },

    subsections: {
      get () {
        return this.$store.getters.subsections
      },
      set (subsections) {
        this.$store.commit('SET_SUBSECTIONS', subsections)
      }
    },

    subsectionOptions () {
      let subsectionOptions = []
      this.subsections.forEach(subsection => {
        const isNotUsedSubsection = subsection.parent.id === null || subsection.parent.id === this.activeSubsectionGroupId

        if (isNotUsedSubsection) {
          subsectionOptions.push({
            label: subsection.label,
            value: subsection._id
          })
        }
      })
      return subsectionOptions
    },

  },

  methods: {
    async addSubsectionGroup () {
      const { _id } = await this.$store.dispatch('ADD_NEW_SUBSECTION_GROUP')
      this.activeSubsectionGroupId = _id
    },

    addTag () {
      this.$store.dispatch('GET_TAG_SCHEMA').then(res => {
        this.activeSubsectionGroup.tags.push(res.data)
      })
    },    

    async cloneSubsectionGroup (subsection) {
      const { _id } = await this.$store.dispatch('CLONE_SUBSECTION_GROUP', subsection)
      this.activeSubsectionGroupId = _id      
    },

    closeModal () {
      this.activeSubsectionGroupId = null
      this.$store.dispatch('FETCH_SUBSECTION_GROUPS')
    },

    deleteSubsectionGroup (id) {
      if (confirm('Are you sure?')) {
        this.$store.dispatch('DELETE_SUBSECTION_GROUP', id)
      }
    },

    saveSubsectionGroup (subsectionGroup) {
      this.$store.dispatch('SAVE_SUBSECTION_GROUP', subsectionGroup)

      // save subsections
      subsectionGroup.subsectionIds.forEach(subsectionId => {
        const subsection = _.find(this.subsections, subsection => subsectionId === subsection._id)
        const subsectionUpdate = {
          _id: subsection._id,
          marker: subsection.marker,
          polygon: subsection.polygon,
          parent: {
            id: subsectionGroup._id,
            type: 'subsectionGroup'
          }
        }

        this.$store.dispatch('SAVE_SUBSECTION', subsectionUpdate)
      })      
    },

    backgroundAssetType (asset) {
      if (asset) {
        if (asset.split('.').pop() === 'mp4') {
          return 'video'
        } else {
          return 'image'
        }
      }

      return ''
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_SUBSECTIONS')
    this.$store.dispatch('FETCH_SUBSECTION_GROUPS')
  }
}
</script>

<style lang="scss" scoped>
.draggable-container {
  pointer-events: none;
  position: relative;
  aspect-ratio: 3190 / 1960;

  &__bg {
    position: relative;
    user-select: none;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

  }
}
</style>